enum ParentalAge {
  ADULTS = 'ADULTOS',
  ALL_AGES = 'TP',
  SEVEN = '7',
  TWELVE = '12',
  SIXTEEN = '16',
  EIGHTEEN = '18',
}

enum ParentalTimeFrames {
  MORNING = 'Morning',
  AFTERNOON = 'Afternoon',
  NIGHT = 'Night',
}

export { ParentalAge, ParentalTimeFrames };
